import Schedule from './_Schedule';

export default Schedule;
